import { ChangeDetectionStrategy, Component, input, model, output} from '@angular/core';
import { AbstractComponent } from '@spike/scaffolds';
import { TableModule } from 'primeng/table';
import { Tag } from 'primeng/tag';
import { CommonModule } from '@angular/common';
import { AvanzamentiPosizioni } from '../../models/avanzamenti-posizioni.model';
import { WorkflowState } from 'src/app/features/workflow/models/workflow-status.enum';
import { SortingModel } from 'src/app/features/shared/models/sorting.model';


@Component({
  changeDetection: ChangeDetectionStrategy.OnPush,
  selector: 'spike-positions-table',
  providers:[],
  imports: [TableModule, Tag, CommonModule],
  templateUrl: './positions-table.html'
})

export class PositionsTableComponent extends AbstractComponent{
    items = input.required<AvanzamentiPosizioni[]>();
    workflowState= input.required<WorkflowState>();
    onSelect = output<AvanzamentiPosizioni>();
    sorting = model.required<SortingModel>();

    sort(event: any){
      this.sorting.set({ orderByClause: event.field, orderDirection: event.order === 1 ? 'asc' : 'desc' });
    }

    getPositionStatusDescription(stateId:number): string | undefined {
      const positionWorkflow= this.workflowState().list!.find(x => x.id == stateId)?.label;
      return positionWorkflow;
    }
     getPositionStatusSeverity(stateId:number): 'secondary' | 'success' | 'info' | 'warn' | 'danger' {
      const positionWorkflow= this.workflowState().list!.find(x => x.id == stateId)?.severity;
      return positionWorkflow ?? 'info';
    }

}
  

